import { motion, useReducedMotion } from 'motion/react';
import { memo } from 'react';

import {
  WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_DURATION_S,
  WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_STAGGER_S,
  WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_TRANSLATE_Y_PX,
} from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentZeroStateEntrance';
import { WorkspaceAgentPromptCard } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/prompt-cards/WorkspaceAgentPromptCard';
import { type WorkspaceAgentPromptCardThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/prompt-cards/WorkspaceAgentPromptCardImageStack';

export type WorkspaceAgentPromptCardCarouselSlideProps = {
  buttonLabel: string;
  id: string;
  index: number;
  isDisabled: boolean;
  onSelect: (id: string) => void;
  thumbnails: readonly WorkspaceAgentPromptCardThumbnail[];
  subtitle: string;
  title: string;
};

export const WorkspaceAgentPromptCardCarouselSlide = memo(
  ({
    buttonLabel,
    id,
    index,
    isDisabled,
    onSelect,
    thumbnails,
    subtitle,
    title,
  }: WorkspaceAgentPromptCardCarouselSlideProps) => {
    const shouldReduceMotion = useReducedMotion();

    return (
      <motion.li
        animate={{ opacity: 1, y: 0 }}
        className="w-5/6 shrink-0 snap-start"
        data-prompt-card-slide=""
        initial={shouldReduceMotion ? false : { opacity: 0, y: WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_TRANSLATE_Y_PX }}
        transition={{
          delay: index * WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_STAGGER_S,
          duration: WORKSPACE_AGENT_ZERO_STATE_ENTRANCE_DURATION_S,
          ease: 'easeOut',
        }}
      >
        <WorkspaceAgentPromptCard
          buttonLabel={buttonLabel}
          id={id}
          isDisabled={isDisabled}
          onSelect={onSelect}
          thumbnails={thumbnails}
          subtitle={subtitle}
          title={title}
        />
      </motion.li>
    );
  },
);

WorkspaceAgentPromptCardCarouselSlide.displayName = 'WorkspaceAgentPromptCardCarouselSlide';
